import * as yup from 'yup'
import { checkLastChar } from './aggregatorSchema'
import { NO_SPECIAL_CHAR, OOS_THRESHOLD_REGEX } from 'utils/constants'
import {
  LAST_MILES,
  storeFormFields as SFF,
} from 'components/storeManagement/utils'

export const createStoreSchema = yup
  .object()
  .shape({
    [SFF.STORE_NAME.key]: yup
      .string()
      .trim()
      .required(`${SFF.STORE_NAME.label} is required field`)
      .matches(NO_SPECIAL_CHAR, `Please Enter Valid ${SFF.STORE_NAME.label}.`),
    [SFF.STORE_ID.key]: yup
      .string()
      .trim()
      .required(`${SFF.STORE_ID.label} is required field`)
      .test(
        'last-char-check',
        `Please Enter Valid ${SFF.STORE_ID.label}.`,
        (value) => checkLastChar(value),
      )
      .matches(NO_SPECIAL_CHAR, `Please Enter Valid ${SFF.STORE_ID.label}`),
    [SFF.STORE_IS_ACTIVE.key]: yup.boolean(),
    [SFF.STORE_LAST_MILE.key]: yup
      .string()
      .oneOf(LAST_MILES)
      .required('Please select a valid Last Mile'),
    [SFF.STORE_INVOICE_PREFIX_CODE.key]: yup
      .string()
      .trim()
      .required(`${SFF.STORE_INVOICE_PREFIX_CODE.label} is required field`),
    [SFF.STORE_TALABAT_ID.key]: yup.string().trim().optional(),
    [SFF.STORE_INSTASHOP_IDENTIFIER.key]: yup.string().trim().optional(),
    [SFF.STORE_OOS_THRESHOLD.key]: yup
      .string()
      .trim()
      .required(`${SFF.STORE_OOS_THRESHOLD.label} is required field`)
      .matches(OOS_THRESHOLD_REGEX, {
        message: 'OOS Threshold must be a positive integer',
      }),
  })
  .required()

export const updateStoreSchema = createStoreSchema.shape({
  [SFF.STORE_ID.key]: yup.string().optional(),
})
